<div class="form-group">
  <label class="form-control-label" [innerHTML]="model.value"></label>
</div>
